import claimMessages from '@/modules/Claim/i18n/it'
import damageMessages from '@/modules/Damage/i18n/it'
import appointmentMessages from '@/modules/Appointment/i18n/it'
import documentMessages from '@/modules/Document/i18n/it'

export default {
  claim: { ...claimMessages },
  damage: { ...damageMessages },
  appointment: { ...appointmentMessages },
  document: { ...documentMessages },

  // actions
  actions: {
    addDamage: 'Aggiungi',
    login: 'Accesso',
    select: 'Seleziona',
    clear: 'Pulire',
    continue: 'Continua',
    cancel: 'Cancella',
    import: 'Importazione',
    export: 'Esportazione',
    exportAll: 'Esportare tutti',
    selectFile: 'Selezionare il file',
    search: 'Cerca',
    save: 'Salva',
    delete: 'Cancellare',
    suppress: 'Cancellare',
    confirmAndContinue: 'Confermare e continuare',
    confirmDommages: 'Convalidare i danni',
    goBack: 'Torna indietro',
    addMoreDamage: 'Aggiungi dann',
    accept: 'Accetta'
  },

  // common damages
  commonDamages: {
    emptyData: 'Nessun dato relativo a questo danno è stato specificato'
  },

  // view: addDamages
  addDamages: {
    title: 'Ci dica di più sui suoi danni',
    buttonTitle: 'Aggiungere danni'
  },

  // view: multidamageList
  multidamageList: {
    delete: 'Cancellare',
    inputTitle: 'Per favore, diteci le dimensioni della vostra camera',
    inputHint: 'In metri quadrati',
    btnContinue: 'Confermare e continuare',
    btnAddDamage: 'Specificare questi danni',
    btnAddDamagePhotoclaim: 'Scatta una foto del danno',
    btnAddDamageModal: 'Conferma di questo danno',
    btnAddAllDamages: 'Prossimo',
    calculateSurfaceLink: {
      text1: 'Non conosci la superficie?',
      text2: 'Possiamo aiutarvi a calcolarlo',
      link: 'Calcolare la superficie'
    },
    calculateSurfaceModal: {
      title: 'Calcolare l’area',
      input1: 'Quanti passi hai contato attraverso la larghezza della stanza?',
      input2: 'Quanti passi hai contato lungo la lunghezza della stanza?',
      inputErrorText: 'Questo deve essere un valore numerico maggiore di 1',
      text: 'Per misurare la vostra stanza, abbiamo bisogno di conoscere la larghezza e la lunghezza. Per fare questo, vi chiediamo di stare in un angolo e da lì, per favore, camminate lungo entrambi i lati e registrate il numero di passi della larghezza e della lunghezza della vostra stanza.'
    }
  },

  // view: damageMobilier
  damageMobilier: {
    search: {
      predictibles: 'Scegli tra le nostre categorie più popolari:',
      containerInputs: 'Cerca le nostre categorie',
      categoryList: 'Risultati della ricerca',
      containerEmptyTxt1: 'La tua ricerca',
      containerEmptyTxt2: 'non ha trovato',
      containerEmptyTxt3: 'risultati'
    },
    category: {
      inputTextError: 'Campi obbligatori - valore numerico',
      modal1: 'Prima di continuare',
      modal2: 'Si prega di controllare che questi dati siano corretti:',
      date: 'Data di acquisto',
      price: 'Prezzo d’acquisto',
      buttonsNextActionsTitle: 'Sì, questo è corretto',
      buttonsNextActionsTitleWhiteBtn: 'No, modifica'
    },
    damageResultUptec: {
      title:
        'La valutazione del suo danno sarà fatta utilizzando questo modello:'
    }
  },

  // view: damageItems
  damagedItems: {
    buttonTitle: 'Prossimo',
    defaultTitle: 'Quali parti sono state colpite?',
    defaultText: 'Indicare in quali stanze si è verificato il danno.'
  },

  // view: damagedParts
  damagedParts: {
    buttonTitle: 'Prossimo',
    selectParts:
      'Indicare quali supporti sono stati colpiti o se è necessaria una pulizia'
  },

  // view: damageDetails
  damageDetails: {
    surfaceSmallText: 'In metri quadrati',
    titleFileInputEnsemble:
      'Foto d’insieme - Si prega di stare il più lontano possibile dal danno',
    titleFileInputPres:
      'Foto ravvicinate - Si prega di avvicinarsi il più possibile al danno',
    errorPhoto:
      'Allega la foto in formato .png o .jpg o .jpeg. Non più grande di 6 MB.'
  },

  // view: damagesConfirmed
  damagesConfirmed: {
    titleDamagesConfirmed: 'Riepilogo dei danni',
    photosEnsemble:
      'Foto d’insieme - Si prega di stare il più lontano possibile dal danno',
    photosPres:
      'Foto ravvicinate - Si prega di avvicinarsi il più possibile al danno'
  },

  // component: furniture
  furniture: {
    title: 'Mobili',
    empty: {
      short: 'Riferimento di reclamo mancante',
      long: 'Per aggiungere i danni ai mobili, inserire il riferimento del sinistro'
    },
    kindOfProperty: 'Tipo di proprietà',
    kindOfPropertyOptions: {
      owner: 'Proprietario',
      renter: 'Inquilino'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    materialListBtn: 'Elenco delle attrezzature'
  },
  // notification
  notifications: {
    error: {
      0: {
        title:
          'Il codice postale che hai inserito in precedenza non è accettato',
        body: "Errore durante l'azione"
      },
      400: {
        title: 'Campo obbligatorio non compilato',
        body: 'Si prega di rivedere i campi che non sono compilati'
      },
      500: {
        title: 'Errore',
        body: 'Si è verificato un errore'
      },
      409: {
        title: 'Errore di identificazione',
        body: 'Il reclamo esiste già'
      },
      title: 'Il codice postale che hai inserito in precedenza non è accettato',
      body: "Errore durante l'azione"
    },
    addDamage: {
      title: 'Danno creato',
      body: 'Il danno è stato creato correttamente'
    },
    newSinister: {
      title: 'Nuovo reclamo',
      body: "L'ID della richiesta è stato cambiato"
    },
    deleteDamage: {
      title: 'Danno rimosso',
      body: 'Il danno è stato rimosso correttamente'
    },
    pdfDamages: {
      title: 'Rapporto creato',
      body: 'Rapporto creato correttamente'
    },
    pdfMaterial: {
      title: 'Rapporto creato',
      body: 'Rapporto creato correttamente'
    },
    mailPdfMaterial: {
      title: 'Email inviata',
      body: 'Email inviata correttamente',
      error: {
        title: 'Email non valida',
        body: 'Per favore, inserisci un’email corretta'
      }
    },
    moCalculation: {
      title: 'Prezzo aggiornato',
      body: 'Ricaricare il rapporto corrente'
    },
    changeLanguage: {
      title: 'Cambiare lingua',
      body: 'Referral'
    },
    loadSinisterOK: {
      title: 'Rivendicazione caricata',
      body: 'Aggiornare le informazioni'
    },
    loadSinisterKO: {
      title: 'Errore di reclamo',
      body: 'Errore durante il caricamento della richiesta'
    },
    paramChanged: {
      title: 'Parametro cambiato',
      body: 'La tabella verrà aggiornata automaticamente.'
    },
    user: {
      isRequired: {
        title: 'Campi obbligatori mancanti',
        body: 'Si prega di compilare correttamente tutti i campi'
      },
      isEmail: {
        title: 'Email sbagliata',
        body: 'L’email inserita non è valida'
      },
      isSamePassword: {
        title: 'Le password non corrispondono',
        body: 'Le password non corrispondono'
      },
      createdUser: {
        title: 'Utente creato',
        body: 'Vista in fase di aggiornamento'
      },
      modifiedUser: {
        title: 'Utente cambiato',
        body: 'Vista in fase di aggiornamento'
      },
      deletedUser: {
        title: 'Utente cancellato',
        body: 'Vista in fase di aggiornamento'
      },
      error: {
        400: {
          title: 'Mancano i campi obbligatori',
          body: 'Si prega di controllare i campi richiesti'
        },
        500: {
          title: 'Errore',
          body: 'Si è verificato un errore'
        },
        409: {
          title: 'Errore di accesso',
          body: 'L’utente esiste già'
        }
      }
    },
    images: {
      uploadError: {
        title: 'Errore di caricamento',
        text: 'Allega la foto in formato .png o .jpg o .jpeg. Non più di 6 MB.'
      },
      inputImgError: {
        title: 'Errore di caricamento',
        text: 'Si è verificato un errore durante il caricamento della foto. È possibile continuare senza aggiungere foto'
      }
    }
  },

  // datePicker
  datePicker: {
    literal: 'Data di acquisto'
  },

  // damagesTypes view
  damagesTypes: {
    titleNavbar: "Qual è l'origine dei tuoi danni?"
  },

  // damageValidation
  damageValidation: {
    amount: '{amount} €',
    actions: {
      primary: 'Sì, accetto il compenso proposto',
      secondary: 'Vorrei discutere questa valutazione con un consulente',
      tertiary: 'No, volevo un’altra soluzione'
    },
    materialsList: 'Elenco delle attrezzature',
    upptecDossier: 'Rapporto sui mobili'
  },

  // common
  common: {
    surface: 'Superficie',
    line: 'Linea',
    distance: 'Distanza',
    actualCalc: 'Calcolo in corso',
    selectOnTheMap: 'Selezionare sulla mappa per misurare',
    mapAction: 'Mappa delle misure',
    mapActionLine: 'Misurare la distanza sulla mappa',
    min: 'Minimo',
    max: 'Massimo',
    total: 'Total',
    recommended: 'Consigliato',
    standard: 'Standard',
    noFile: 'Nessun file selezionato',
    email: 'E-mail',
    search: 'Cerca',
    results: 'Risultati',
    noresults: {
      short: 'Nessun risultato trovato',
      long: 'Non ci sono risultati per la tua ricerca'
    },
    true: 'Sí',
    false: 'No',
    noOptions: 'Nessuna opzione',
    noSelected: 'Nessuna selezionata.',
    agentView: 'vista agente',
    managerView: 'vista manager',
    unit: '0 di unità | x {conteggio} unità | x {conteggio} di unità'
  },

  // view: error
  errorView: {
    title: 'Si è verificato un errore',
    text: 'Il nostro team sta lavorando per risolvere il problema il più rapidamente possibile.'
  },

  timedoutView: {
    title: 'Il link è scaduto',
    text: {
      upper: `Siamo spiacenti, ma il collegamento è scaduto e non è più valido`,
      lower: `Contatta i nostri operatori per un nuovo collegamento`
    }
  },

  // cart
  cart: {
    title: 'Elenco dei danni introdotti'
  },

  // component: form-container
  formContainer: {
    mursTitle: 'Numero di pareti interessate'
  },

  // component: customImage
  customImageInput: {
    default: {
      takeScreenshot: 'Inquadrare il danno',
      repeat: 'Ripetere',
      usePhoto: 'usa foto'
    },
    guideCamera: {
      takeScreenshot: 'Inquadrare il danno nella {guideIndexLiteral} guida',
      first: 'prima',
      second: 'seconda',
      third: 'terza'
    },
    cornersCamera: {
      takeScreenshot: 'Dal centro della stanza, fotografa ogni angolo',
      endPhotos: 'Finalizzare'
    }
  },
  otpView: {
    title: 'Buongiorno',
    text: {
      upper: `Benvenuto nel tuo spazio "I miei danni" che ti permette di descrivere la completezza dei tuoi danni.`,
      upper2: `Per accedervi, inserisci il codice inviato al tuo telefono all'indirizzo `,
      upper3: `Questo passaggio può richiedere fino a 2 minuti.`,
      lower1: `Inserisci il tuo codice di verifica.`,
      lower2: `Un codice è stato inviato al tuo telefono all'indirizzo `,
      nocode: `Non hai ricevuto il tuo codice ?`,
      resend: 'Invia nuovamente un SMS',
      resendNotification: 'Messaggio inoltrato',
      errorNotification: 'Codice errato',
      popup: {
        text1: `Se non hai ricevuto il codice di autenticazione, ti consigliamo questi tre passaggi : `,
        list1_1: `Controlla che il numero di telefono`,
        list1_2: `corrisponde al tuo`,
        list2: `Se il numero corrisponde, chiudi questa finestra e fai clic su "Invia nuovamente SMS"`,
        list3: `Se il numero non corrisponde, ti invitiamo a inserirlo sul tuo `,
        link1: `Area clienti`,
        text2: `Un consulente Sogessur ti richiamerà entro 24 ore.`
      }
    }
  },

  // legal conditions
  cookiesAndLegal: {
    general: {
      title: 'Termini e Condizioni',
      paragraph1:
        'Prima di iniziare, si prega di rivedere il nostro utilizzo dei cookie nel browser e i nostri termini e condizioni di servizio. Cliccando sul pulsante Accetto confermi di aver letto e compreso le condizioni relative a questo servizio.'
    },
    cookies: {
      title: 'INFORMATIVA SUI COOKIE',
      paragraph1: {
        list1: `Ti verrà quindi mostrata la Cookie Policy (di seguito denominata “la Cookie Policy” o “la Policy”) che disciplina la Piattaforma Web https://mavalue.plataforma-smart.com/ (di seguito denominata “la Platform”, o “MAValue”), proprietà di Multiassistance, S.A. (di seguito denominata “Multiassistance” o “noi”).`,
        list2: `Lo scopo di questa politica sui cookie è di aiutarti a comprendere l'uso fatto su questa piattaforma web dei cookie, il loro tipo, il loro scopo e la loro durata e di indicarti anche le opzioni che hai per configurare, amministrare o rifiutare questi.`,
        list3: `PRENDERE QUALCHE MINUTO PER LEGGERE LA NOSTRA POLITICA SUI COOKIE, NON CI VUOLE TEMPO. VOGLIAMO SPIEGARE IN MODO SEMPLICE, CHIARO E TRASPARENTE COME ELABORIAMO E PROTEGGIIAMO I TUOI DATI PERSONALI E I TUOI DIRITTI. LA TUA SICUREZZA E QUELLA DEI TUOI DATI PERSONALI È FONDAMENTALE PER NOI E PRENDIAMO MOLTO SERIAMENTE LA LORO ADEGUATA PROTEZIONE.`,
        list4: `SI RACCOMANDA INOLTRE DI LEGGERE LA NOSTRA POLITICA SULLA PRIVACY.`
      },
      paragraph2: {
        title: `Cosa sono i cookie?`,
        body: `I cookie sono piccoli file o piccoli dispositivi scaricati e memorizzati all'interno del tuo terminale (ossia il dispositivo da cui accedi alla Piattaforma: il computer, il Telefono cellulare, il Tablet o qualsiasi altro dispositivo connesso…) e che consentono alla Piattaforma o al sito web per ricordare le informazioni relative alla tua visita.
        I cookie possono essere di diverso tipo a seconda di diversi parametri:`,
        list1: `A seconda del soggetto che gestisce il team o il dominio da cui vengono inviati i cookie e da dove vengono elaborati i dati ottenuti, possiamo distinguere quanto segue:`,
        list2: `Cookie specifici per noi: sono quelli che vengono inviati all'apparecchiatura terminale dell'utente da apparecchiature o da un dominio gestito da Multiassistance e da cui parte il servizio richiesto dall'utente.`,
        list3: `Cookie di terze parti: sono quelli che vengono inviati all'apparecchiatura terminale dell'utente da apparecchiature o da un dominio non gestiti da Multiassistance, ma da un altro soggetto che elabora i dati ottenuti dai cookie. Quando i cookie sono installati da apparecchiature o da un dominio gestito da Multiassistance, ma le informazioni da essi raccolte sono gestite da una terza parte, non possono essere considerati cookie specifici di Multiassistance. In tal senso Multiassistance potrà avvalersi dei servizi di società di analisi e misura per misurare e/o analizzare il comportamento di navigazione degli utenti sulla piattaforma, e, a tal fine, che agiscano per suo conto e nella sua rappresentazione, in ragione della analisi dei dati ottenuti dall'uso dei cookie di questi servizi, il tutto con l'obiettivo di migliorare il servizio fornito da Multiassistance.`,
        list4: `En fonction de la finalité pour laquelle sont traitées les données obtenues à travers les cookies, on peut distinguer entre:`,
        list5: `Cookie tecnici: sono quelli che consentono all'utente di navigare attraverso la piattaforma e utilizzare le diverse opzioni o i diversi servizi ivi disponibili quali, ad esempio, controllo del traffico e comunicazione dei dati, identificazione della sessione, accesso a dati di accesso, promemoria degli elementi costitutivi di una richiesta di registrazione o partecipazione a un evento, utilizzo di elementi di sicurezza durante la navigazione, salvataggio di contenuti per la trasmissione di video o suoni o condivisione di contenuti nei social network.`,
        list6: `Cookie di personalizzazione: sono i cookie che consentono all'utente di accedere al servizio con determinate caratteristiche generali predefinite secondo una serie di criteri presenti sul terminale dell'utente quali, ad esempio, la lingua, il tipo di browser utilizzato per accedere al servizio, la configurazione regionale per accedere al servizio, tra le altre.`,
        list7: `Cookie di analisi: sono quelli che consentono al loro gestore di monitorare e analizzare il comportamento degli utenti dei siti web a cui sono collegati. Le informazioni raccolte tramite questa tipologia di cookie sono utilizzate per misurare l'attività sulla piattaforma e per l'elaborazione dei profili di navigazione degli utenti sui siti in questione, sulle applicazioni e sulle piattaforme in un'ottica di miglioramento: in base alla analisi dei dati consultati dagli utenti del servizio.`,
        list8: `Cookie pubblicitari: sono quelli che consentono la gestione nel modo più efficiente possibile degli spazi pubblicitari eventualmente inseriti dall'editore in una pagina web, un'applicazione o una piattaforma da cui il servizio richiesto verrà essere fornito in base a criteri quali contenuto modificato o frequenza di visualizzazione degli annunci pubblicitari.`,
        list9: `Cookie di pubblicità comportamentale: sono quelli che consentono la gestione, nel modo più efficiente possibile, degli spazi pubblicitari che l'editore, se necessario, avrebbe incluso all'interno di un sito web, un'applicazione o una piattaforma da cui sarà il servizio richiesto fornito. Questi cookie salvano informazioni sul comportamento dell'utente che è stato ottenuto attraverso l'osservazione continua delle sue abitudini di navigazione, consentendo lo sviluppo di un profilo specifico basato su di esso.`,
        list9_1: `A seconda del periodo di tempo in cui sono attivi all'interno dell'apparecchiatura terminale (temporalità), possiamo distinguere quanto segue:`,
        list10: `Cookie di sessione: sono cookie progettati per raccogliere e salvare dati durante l'accesso dell'utente alla piattaforma.`,
        list11: `Cookie persistenti: sono i cookie in cui i dati continuano a essere salvati all'interno del terminale e che possono essere elaborati durante un periodo di tempo definito dal responsabile del cookie, e che può variare da pochi minuti a diversi anni.`,
        footer: `Puoi consultare le informazioni sui cookie e altri traccianti fornite dalla Commissione nazionale per l'informatica e le libertà (CNIL) facendo clic qui.`
      },
      paragraph3: {
        title: `Quali cookie sono utilizzati sulla piattaforma?`,
        body: `Questa piattaforma utilizza cookie tecnici necessari per abilitare e ottimizzare la navigazione dell'utente e le funzionalità della piattaforma.
        I cookie utilizzati sono necessari per consentire la navigazione sulla Piattaforma e per garantirne il corretto funzionamento, pertanto non possono essere rifiutati dall'utente e la loro disattivazione o cancellazione comporterà l'impossibilità di utilizzare la Piattaforma.
        Di seguito, si individuano i cookie utilizzati all'interno di questa Piattaforma: `,
        list1: `Cookie`,
        list1_1: `mavalue.plataforma-smart`,
        list2: `Scopo`,
        list2_1: `Cookie per mantenerti connesso`,
        list3: `Gestione`,
        list3_1: `Pulisci`,
        list4: `Durata`,
        list4_1: `1 anno`
      },
      paragraph4: {
        title: `Aggiornamenti e modifiche alla cookie policy.`,
        body: `La presente Cookie Policy può essere modificata in base a requisiti legislativi, regolamentari o al fine di adeguare la presente policy alle indicazioni impartite dalla Commissione Nazionale per l'Informatica e le Libertà (CNIL), a tal fine si consiglia agli utenti di consultarla periodicamente .`
      }
    },
    legal: {
      title: 'AVVISO LEGALE',
      paragraph1: {
        list1: `L'accesso alle soluzioni digitali ea tutte le funzionalità contenute all'interno di questa Piattaforma sono inclusi nei servizi appaltati dalla società che ne detiene il diritto di utilizzo (la società), per conto della quale si acquisisce la condizione di utente delle stesse. L'accesso, la navigazione e l'utilizzo della Piattaforma implica il soddisfacimento della condizione di utente della stessa (d'ora in poi "l'utente") e, quindi, l'adesione all'accettazione espressa e senza riserve da parte dell'utente di tutti i termini e le condizioni contenute nella presente Nota Legale Avviso, per questo ne consigliamo la lettura attenta, affinché in caso di disaccordo, basti non accettarlo con i mezzi previsti a tal fine, fatto che rende impossibile l'utilizzo della Piattaforma, dei servizi e delle funzionalità stabilito tramite quest'ultimo.».`
      },
      paragraph2: {
        title: `INFORMAZIONI GENERALI.`,
        subParagraph1: {
          title: `EDITOR`,
          line1: `MULTIASSISTANCE, S.A. (di seguito denominata “Multiassistance” o “noi”); `,
          line2: `Società per azioni con capitale di 48.494,10 euro`,
          line3: `146 boulevard de Charonne`,
          line4: `75020 Parigi`,
          line5: `Numero di partita IVA intracomunitaria: FR 62413114901`,
          line6:
            'Nome del direttore della pubblicazione: Sig. Íñigo Astarloa Echevarrieta',
          line7: `Tel: 01 40 09 36 60`,
          line8: `E-mail: info@multiassistencia.com; contact.clients@Multiassistance.com `
        },
        subParagraph2: {
          title: `HOSTER`,
          line1: `Amazon Web Services EMEA SARL`,
          line2: `38 avenue John F. Kennedy, L-1855 Lussemburgo`,
          line3: `Fax: 352 2789 0057`
        }
      },
      paragraph3: {
        title: `PIATTAFORMA WEB: UTILIZZO, SCOPO E REGIME LEGALE APPLICABILE.`,
        list1: `Multiassistance è una società specializzata nella gestione e riparazione dei sinistri nelle assicurazioni casa e commerciale per le compagnie assicurative e, nell'ambito di questa attività, fornisce ai propri clienti soluzioni digitali volte all'ottimizzazione e alla digitalizzazione dei loro processi operativi.`,
        list2: `La Piattaforma è il canale attraverso il quale gli utenti autorizzati possono utilizzare le diverse soluzioni che hanno contratto o che l'azienda a cui appartengono o con la quale hanno un rapporto di collaborazione ha contratto. `,
        list3: `L'accesso alle soluzioni digitali ea tutte le funzionalità contenute all'interno di questa Piattaforma sono inclusi nei servizi appaltati dalla società che ne detiene il diritto di utilizzo (la società), per conto della quale si acquisisce la condizione di utente delle stesse. L'accesso e l'utilizzo della Piattaforma implica l'accettazione di tutte le presenti condizioni, nonché di ogni altra condizione che possa essere stabilita, modificata e/o estesa sulla base di determinate esigenze presenti o future del Servizio. Multiassistance avrà il diritto di modificare in qualsiasi momento il contenuto delle presenti condizioni nonché i servizi e le funzionalità stabiliti nella Piattaforma, fermo restando che la pubblicazione di tali modifiche in questione e le modifiche con questo mezzo di comunicazione sarà sufficiente, senza tuttavia che ciò non pregiudica la possibilità dell'utente di accettare o meno le modifiche in questione. In caso di mancata accettazione, ciò potrebbe comportare l'impossibilità di utilizzare la Piattaforma per tutte o alcune funzionalità previste da quest'ultima.`
      },
      paragraph4: {
        title: `TERMINI DI ACCESSO E UTILIZZO.`,
        body1: `L'utente si impegna a fare un uso appropriato e lecito della Piattaforma, nonché dei contenuti, prodotti e servizi da essa stabiliti, in conformità con la legislazione applicabile in ogni momento, alle presenti condizioni, al senso morale e in generale buone abitudini accettate oltre che all'ordine pubblico. `,
        body2: `Inoltre, l'utente della Piattaforma accetta quanto segue:`,
        list1: `Garantire l'autenticità, veridicità, aggiornamento e correttezza di tutti i dati comunicati attraverso la Piattaforma, specificando che in caso contrario l'utente sarà l'unico responsabile.`,
        list2: `Utilizzare la Piattaforma esclusivamente per le finalità e le funzionalità concordate da Multiassistance, pertanto è vietato all'utente utilizzare la Piattaforma per qualsiasi altro scopo o altro mezzo.`,
        list3: `Fare un uso legale e legittimo della Piattaforma, evitando ogni uso non autorizzato, fraudolento, illegale o illegittimo della stessa e/o dei contenuti e delle informazioni da essa stabiliti, evitando di violare le presenti Note Legali nonché la normativa applicabile, violare i diritti e gli interessi legittimi di Multiassistance o di qualsiasi altra terza parte che possa essere pregiudicata da questa azione.`,
        list4: `Non causare danni ai sistemi fisici o logici della Piattaforma, dei suoi fornitori o di terzi; non tentare di violare le misure di sicurezza o di autenticazione delle stesse, non compiere azioni che causino una saturazione sproporzionata o non necessaria dell'infrastruttura o dell'ambiente di comunicazione relativo alla Piattaforma e al Servizio, aggredendo quest'ultimo in un modo o nell'altro. Multiassistance potrà attuare ogni misura preventiva o correttiva ritenuta necessaria per tutelare i propri interessi in conformità al corretto funzionamento della Piattaforma, del Servizio e delle funzionalità specificate.`,
        list5: `Non introdurre o diffondere in rete virus informatici o qualsiasi altro sistema fisico o logico che possa causare danni quali virus, codice dannoso o altri programmi o archivi dannosi.`,
        list6: `Non tentare di accedere, utilizzare e/o manipolare dati o qualsiasi altra informazione elaborata dalla Piattaforma.`,
        list7: `In particolare, ea titolo meramente informativo e non esaustivo, l'utente si impegna a non trasmettere, diffondere o mettere a disposizione di terzi informazioni, dati, contenuti o messaggi che possano ledere i diritti di Multiassistenza o di terzi.`,
        list8: `Non accedere senza autorizzazione o utilizzare una falsa identità, impersonare l'identità di terzi o utilizzare un profilo o compiere qualsiasi altra azione che possa generare confusione o fuorviare sulla corretta identità dell'utente in questione.`
      },
      paragraph5: {
        title: `PROPRIETA' INDUSTRIALE E INTELLETTUALE.`,
        list1:
          "L'utente riconosce e accetta che tutti i diritti di proprietà intellettuale e industriale sulla Piattaforma e tutti i suoi elementi associati corrispondono a Multiassistance oa terzi che abbiano specificamente autorizzato Multiassistance a tale scopo.",
        list2: `In nessun caso l'accesso o la navigazione sulla Piattaforma comporta alcun tipo di recesso, trasmissione, licenza o trasferimento totale o parziale di tali diritti in questione, salvo che non sia espressamente previsto per iscritto.`,
        list3: `Tutti i diritti di proprietà intellettuale e industriale relativi ai contenuti e/o ai servizi della Piattaforma sono riservati e, in particolare, è vietato modificare, copiare, riprodurre, comunicare pubblicamente, trasformare o distribuire, con qualsiasi mezzo o formato , tutti o parte dei contenuti ivi inclusi per scopi pubblici o commerciali, salvo previa autorizzazione espressa e scritta dei rispettivi proprietari.`,
        list4: `L'utente contrariamente a tali limitazioni e divieti riconosce di assumersi la responsabilità esclusiva, sollevando così Multiassistance, o qualsiasi altra terza parte che possa essere pregiudicata dall'azione dell'utente da qualsiasi responsabilità.`
      },
      paragraph6: {
        title: `ESCLUSIONE DI GARANZIE E RESPONSABILITA'.`,
        list1: `Multiassistance adotterà diverse misure per proteggere la Piattaforma ei contenuti dagli attacchi informatici di terzi. In ogni caso, è importante che gli utenti siano responsabili dell'adozione di tutte le misure tecniche appropriate per controllare ragionevolmente le minacce a cui sono esposti, compreso l'aggiornamento dei sistemi per rilevare software dannoso, come virus, trojan, ecc. nonché patch di sicurezza per i browser interessati.`,
        list2: `L'utente è responsabile della sicurezza dei propri codici di accesso e deve evitarne l'uso da parte di terzi non autorizzati e adottare le misure di sicurezza necessarie per mantenere la riservatezza dei sistemi o codici di accesso e di verifica stabiliti in relazione alla Piattaforma. Multiassistance declina ogni responsabilità in caso di negligenza, imprudenza o uso improprio da parte dell'utente o di terzi non autorizzati e in nessun caso sarà responsabile per danni e pregiudizi che possano derivare da tale accesso non autorizzato.`,
        list3: `Multiassistance si riserva il diritto di sospendere, senza preavviso, l'accesso agli utenti che, secondo il suo criterio, non rispettino le regole di utilizzo della Piattaforma e, inoltre, di esercitare i provvedimenti di legge in materia, senza che questo non genera alcun diritto di risarcimento a beneficio dell'utente che potrebbe essere stato colpito.`,
        list4: `Multiassistance declina ogni responsabilità derivante da danni e perdite di qualsiasi tipo che possano derivare dall'uso dei servizi e dei contenuti da parte degli utenti, o che possano derivare dalla mancanza di informazioni, accuratezza o veridicità che questi forniscono nell'ambito della Piattaforma e il Servizio. In nessun caso Multiassistance potrà essere ritenuta responsabile per l'uso che gli utenti e/o terzi fanno della Piattaforma, nonché per eventuali danni e perdite che ne possano derivare.`
      },
      paragraph7: {
        title: `LA MODIFICA DELLE NOTE LEGALI.`,
        list1: `Multiassistance si riserva il diritto di modificare le informazioni contenute nelle presenti note legali, al fine di adeguarle ai futuri sviluppi legislativi, dottrinali o giurisprudenziali derivanti dalla domanda, sia per finalità tecniche, operative, commerciali, societarie e imprenditoriali, dandone preventivamente e ragionevole preavviso agli utenti delle modifiche in atto il prima possibile. In ogni caso, si raccomanda, ogni volta che si accede alla Piattaforma, di leggere attentamente le note legali.`,
        list2: `In caso di dubbio relativo a queste note legali, l'utente può contattare Multiassistance via e-mail al seguente indirizzo di posta elettronica: info@multiassistencia.com`
      }
    }
  },
  textDescriptionError:
    'Completare la descrizione del danno prima di continuare'
}
